import styled from 'styled-components';
import { Flex, Box } from 'dash-ui';
import LogoImg from 'assets/images/png/logo.png';

const HeaderStyle = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  background-color: ${({ theme }) => theme.colors.white};
  display: none;
  @media ${({ theme }) => theme.devices.mobile} {
    display: flex;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    display: flex;
  }
  position: fixed;
  top: 0;
  z-index: 2;
`;
const LogoContainer = styled(Box)`
  @media ${({ theme }) => theme.devices.mobile} {
    margin-left: ${({ theme }) => theme.space * 4}px;
  }
  margin-left: ${({ theme }) => theme.space * 19}px;
`;

function Header() {
  return (
    <HeaderStyle
      minHeight={56}
      flex={1}
      w="100%"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex>
        <LogoContainer ml={19}>
          <img src={LogoImg} alt="Dash Logo" />
        </LogoContainer>
      </Flex>
    </HeaderStyle>
  );
}

export default Header;
